
import { mapGetters } from 'vuex'
import { getThumbnailUrlByCid } from '@/utils/ipfs'
import { fetchCoinPriceFull } from '@/services/prices'
import { RARIBLE_ORIGIN_FEE } from '@/utils/constants'
import modals from '~/services/modals'

export default {
  name: 'ModalConfirmation',

  props: {
    title: {type: String, default: ''},
    tag: {type: String, default: ''},
    image: {type: String, default: ''},
    itemDesc: {type: String, default: ''},
    quantity: {type: Number, default: 1},
    itemPrice: {type: Number, default: 0},
    isSponsored: {type: Boolean, default: false},
    gas: {type: Function, default: () => {}},
    onConfirm: {type: Function, default: () => {}},
  },

  data() {
    return {
      gasLimit: 0,
      ethPrice: 0,
      isLoadingGas: false,
    }
  },

  computed: {
    ...mapGetters('wallet', ['ethBalance', 'usdcBalance']),
    imageUrl() { return this.image ? getThumbnailUrlByCid(this.image, 220) : '' },
    marketplaceFee() { return this.itemPrice * (RARIBLE_ORIGIN_FEE / 100) },
    networkFee() { return this.isSponsored ? 0 : this.gasLimit },
    networkFeeUSD() { return this.networkFee * this.ethPrice },
    total() { return this.itemPrice*1 + this.marketplaceFee*1 + this.networkFeeUSD*1 },
    qtyLength() { return this.quantity.toString().length },
    isInsufficientGas() { return this.networkFee > this.ethBalance },
    isInsufficientUsdc() { return (this.itemPrice*1 + this.marketplaceFee*1) > this.usdcBalance },
  },

  async mounted() {
    this.isLoadingGas = true
    if (this.isSponsored) {
      this.gasLimit = 0
      this.ethPrice = 0
    } else {
      const [g, e] = await Promise.all([this.gas(), fetchCoinPriceFull('ETH')])
      this.gasLimit = g
      this.ethPrice = parseFloat(e.RAW.ETH.USD.PRICE)
    }
    this.isLoadingGas = false
  },

  methods: {
    open() {
      this.$refs.modal.open();
    },

    async confirm() {
      this.quit();
      sessionStorage.setItem('txSponsored', this.isSponsored);
      await this.onConfirm();
    },

    quit() {
      sessionStorage.removeItem('txSponsored');
      this.$refs.modal.quit();
    },

    openRamp() {
      modals.transak({mode: 'BUY'});
    },
  }

}
